import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiDeleteMerchantOrgBlockListRequest,
  DefaultApiUpdateMerchantOrgBlockListRequest,
} from '@src/api/generated/user-api'

export const getMerchantOrgBlock = async (instance: AxiosInstance) => {
  return await userApiDefaultApiFactory(instance).getMerchantOrgBlock()
}

export const deleteMerchantOrgBlockList = async (
  instance: AxiosInstance,
  params: DefaultApiDeleteMerchantOrgBlockListRequest
) => {
  return await userApiDefaultApiFactory(instance).deleteMerchantOrgBlockList(
    params
  )
}

export const updateMerchantOrgBlockList = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateMerchantOrgBlockListRequest
) => {
  return await userApiDefaultApiFactory(instance).updateMerchantOrgBlockList(
    params
  )
}

// Do Not Remove this line ===@import api client===
